import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pied',
  templateUrl: './pied.component.html',
  styleUrls: ['./pied.component.css']
})
export class PiedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
